import { getJobListThunk, getJobTypesListThunk } from '../redux/Job/Job.thunk';
import { Job, JobType } from '../redux/Job/Job.type';
import { useAppDispatch } from './useAppDispatcher.hook';
import { useTranslation } from 'react-i18next';

const useJobsHook = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return {
    getSelectList: async (
      search: string,
      loadedOptions: string | any[],
      { page }: any,
    ) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getJobListThunk({ search, page }));
      return {
        options: data.map((item: Job) => ({
          value: item.id,
          label: item.name,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    getSelectListByIds: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getJobListThunk({ ids }));
      return data.map((item: Job) => ({
        value: item.id,
        label: item.name,
      }));
    },
    getSelectTypesById: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getJobTypesListThunk(ids));
      return data.map((item: JobType) => ({
        value: item.id,
        label: t(item.name),
      }));
    },
  };
};

export default useJobsHook;
